import { render } from "./PCPopupPaleData.vue?vue&type=template&id=afd41e06&scoped=true"
import script from "./PCPopupPaleData.vue?vue&type=script&lang=js"
export * from "./PCPopupPaleData.vue?vue&type=script&lang=js"

import "./PCPopupPaleData.vue?vue&type=style&index=0&id=afd41e06&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd41e06"]])

export default __exports__